import {
    GET_CMS_CERTIFICACIONES
} from "../actions/types";

const initialState = [];
const cmsReducer = function (state=initialState, action) {
    const {type, payload } = action;    
    switch (type) {        
        case GET_CMS_CERTIFICACIONES:
            return {
                ...state,
                contentCertificaciones: payload.data
            }
        default:
            return state;
    }
};

export default cmsReducer;